import { Controller } from "@hotwired/stimulus";

// Local preview of the logo before submit + a "remove" toggle that posts
// `junior_configuration[remove_logo]=1` so the controller knows to purge
// the existing attachment.
export default class extends Controller {
  static targets = ["input", "preview", "removeFlag"];

  pickFile() {
    this.inputTarget.click();
  }

  fileChanged() {
    const file = this.inputTarget.files && this.inputTarget.files[0];
    if (!file) return;
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0";

    if (this._previewUrl) URL.revokeObjectURL(this._previewUrl);
    this._previewUrl = URL.createObjectURL(file);
    this._renderPreview(this._previewUrl);
  }

  remove(event) {
    event.preventDefault();
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1";
    this.inputTarget.value = "";
    if (this._previewUrl) {
      URL.revokeObjectURL(this._previewUrl);
      this._previewUrl = null;
    }
    this._renderPlaceholder();
  }

  _renderPreview(url) {
    this.previewTarget.innerHTML = "";
    const img = document.createElement("img");
    img.src = url;
    img.alt = "Aperçu du logo";
    this.previewTarget.appendChild(img);
  }

  _renderPlaceholder() {
    this.previewTarget.innerHTML = '<i class="fa-solid fa-image" aria-hidden="true"></i>';
  }

  disconnect() {
    if (this._previewUrl) URL.revokeObjectURL(this._previewUrl);
  }
}
